var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19313 0.329525C7.63941 -0.109842 8.36416 -0.109842 8.81044 0.329525L15.6653 7.07821C16.1116 7.51757 16.1116 8.23111 15.6653 8.67047C15.219 9.10984 14.4943 9.10984 14.048 8.67047L8 2.71617L1.95202 8.66696C1.50575 9.10633 0.780988 9.10633 0.334709 8.66696C-0.11157 8.22759 -0.11157 7.51406 0.334709 7.07469L7.18956 0.326011L7.19313 0.329525Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.c1a1995c83ee70ec24a31730a2924af4.svg";
export { ForwardRef as ReactComponent };